import React from 'react';
import { Outlet } from 'react-router-dom';

const IndexTeams = () => {

    return <Outlet/>

}

export default IndexTeams